/* Hartwell DE: mesma logica do hartwell.js, com textos em alemao e cadencia lida de data-weeks */
/* Hartwell — comportamento da página.
   A captura de origem veio sem script nenhum: setas, pontos, miniaturas,
   cronômetro e lista de marcar chegaram inertes. Isto os liga.
   O CSS já converteu os carrosséis em rolagem horizontal nativa
   (.slick-list com overflow-x e scroll-snap), então aqui só se rola o contêiner. */
(function () {
  'use strict';

  /* ─────────────────────────── carrosséis ─────────────────────────── */

  function rolavel(l) { return l && l.scrollWidth > l.clientWidth + 4; }

  // Busca dentro da PRÓPRIA seção do controle, para uma seta de reviews nunca
  // acabar comandando a galeria. Dentro dela, a foto principal tem preferência:
  // as setas da galeria moram na tira de miniaturas, mas quem elas movem é a foto.
  function listaDe(el) {
    var raiz = el.closest('.shopify-section') || el.closest('section') || document.body;
    var principal = raiz.querySelector('[class*="main-slider"] .slick-list');
    if (rolavel(principal)) return principal;
    var achadas = raiz.querySelectorAll('.slick-list');
    for (var i = 0; i < achadas.length; i++) if (rolavel(achadas[i])) return achadas[i];
    return null;
  }

  function slides(l) { return [].slice.call(l.querySelectorAll('.slick-slide')); }

  function passo(l) {
    var s = l.querySelector('.slick-slide');
    if (!s) return l.clientWidth;
    var trilho = l.querySelector('.slick-track');
    var gap = 0;
    if (trilho) {
      var cs = getComputedStyle(trilho);
      gap = parseFloat(cs.columnGap || cs.gap || 0) || 0;
    }
    return Math.round(s.getBoundingClientRect().width + gap);
  }

  function indice(l) { var p = passo(l); return p ? Math.round(l.scrollLeft / p) : 0; }

  function vaiPara(l, i) {
    var n = slides(l).length; if (!n) return;
    i = Math.max(0, Math.min(i, n - 1));
    l.scrollTo({ left: i * passo(l), behavior: 'smooth' });
  }

  // setas — a lista é resolvida NO CLIQUE: no carregamento as imagens ainda
  // não têm largura e nenhum carrossel parece rolável
  [].forEach.call(document.querySelectorAll('.slick-arrow'), function (seta) {
    seta.setAttribute('role', 'button');
    seta.setAttribute('tabindex', '0');
    seta.style.cursor = 'pointer';
    var passoDir = /btn-next|slick-next/.test(seta.className) ? 1 : -1;
    function agir(e) {
      e.preventDefault();
      var l = listaDe(seta); if (!l) return;
      vaiPara(l, indice(l) + passoDir);
    }
    seta.addEventListener('click', agir);
    seta.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') agir(e);
    });

    // A classe .slick-disabled veio congelada no markup da captura, que foi tirada
    // com o carrossel parado na posição zero. Sem sincronizar, a seta de voltar fica
    // a 25% de opacidade para sempre, mesmo havendo para onde voltar.
    var tentativas = 0;
    (function ligaEstado() {
      var l = listaDe(seta);
      if (!l) { if (tentativas++ < 40) return setTimeout(ligaEstado, 250); return; }
      function sincronizaEstado() {
        var fim = l.scrollWidth - l.clientWidth;
        var noComeco = l.scrollLeft <= 2;
        var noFim = l.scrollLeft >= fim - 2;
        var desligada = passoDir < 0 ? noComeco : noFim;
        seta.classList.toggle('slick-disabled', desligada);
        seta.classList.toggle('hw-off', desligada);
      }
      l.addEventListener('scroll', sincronizaEstado, { passive: true });
      window.addEventListener('resize', sincronizaEstado);
      sincronizaEstado();
    })();
  });

  // pontos / barra de progresso
  [].forEach.call(document.querySelectorAll('.slick-dots'), function (ul) {
    var itens = [].slice.call(ul.children);
    itens.forEach(function (li, i) {
      li.style.cursor = 'pointer';
      li.addEventListener('click', function (e) {
        e.preventDefault();
        var l = listaDe(ul); if (l) vaiPara(l, i);
      });
    });
    // a sincronia começa quando a lista existir de fato
    var tentou = 0;
    (function liga() {
      var l = listaDe(ul);
      if (!l) { if (tentou++ < 40) return setTimeout(liga, 250); return; }
      function sincroniza() {
        var at = indice(l);
        itens.forEach(function (li, i) { li.classList.toggle('slick-active', i === at); });
      }
      l.addEventListener('scroll', sincroniza, { passive: true });
      sincroniza();
    })();
  });

  // miniaturas: âncoras #hw-slide-N que rolariam a página inteira
  var principal = document.querySelector('.product-offer__main-slider .slick-list');
  var miniaturas = [].slice.call(document.querySelectorAll('a.hw-thumb, [class*="nav-slider"] a[href^="#hw-slide-"]'));
  if (principal && miniaturas.length) {  // a lista principal existe desde o markup
    miniaturas.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var m = (a.getAttribute('href') || '').match(/hw-slide-(\d+)/);
        vaiPara(principal, m ? parseInt(m[1], 10) : i);
      });
    });
    function marcaMiniatura() {
      var at = indice(principal);
      miniaturas.forEach(function (a, i) { a.classList.toggle('hw-thumb--ativa', i === at); });
      // mantém a miniatura ativa à vista quando a tira rola
      var tira = document.querySelector('.product-offer__nav-slider .slick-list');
      if (tira && rolavel(tira) && miniaturas[at]) {
        var r = miniaturas[at].getBoundingClientRect(), rr = tira.getBoundingClientRect();
        if (r.left < rr.left || r.right > rr.right) {
          tira.scrollTo({ left: tira.scrollLeft + (r.left - rr.left) - 12, behavior: 'smooth' });
        }
      }
    }
    principal.addEventListener('scroll', marcaMiniatura, { passive: true });
    marcaMiniatura();
  }

  /* ─────────────────────────── cronômetro ─────────────────────────── */

  [].forEach.call(document.querySelectorAll('.cd-timer'), function (t) {
    var nums = t.querySelectorAll('.cd-num');
    if (nums.length < 3) return;
    var horas = parseInt(t.getAttribute('data-duration-hours') || '0', 10);
    var mins = parseInt(t.getAttribute('data-duration-minutes') || '0', 10);
    var total = (horas * 3600 + mins * 60) || 7 * 60;
    var chave = 'hw-cd-' + (t.id || 'padrao');
    var fim;
    try {
      fim = parseInt(sessionStorage.getItem(chave) || '0', 10);
      if (!fim || fim < Date.now()) { fim = Date.now() + total * 1000; sessionStorage.setItem(chave, String(fim)); }
    } catch (e) { fim = Date.now() + total * 1000; }
    var dd = function (n) { return (n < 10 ? '0' : '') + n; };
    function tique() {
      var resta = Math.max(0, Math.floor((fim - Date.now()) / 1000));
      if (resta <= 0) {
        clearInterval(rel);
        var txt = t.getAttribute('data-expired-text');
        if (txt) { t.textContent = txt; t.classList.add('cd-expirado'); }
        return;
      }
      nums[0].textContent = dd(Math.floor(resta / 3600));
      nums[1].textContent = dd(Math.floor((resta % 3600) / 60));
      nums[2].textContent = dd(resta % 60);
    }
    tique();
    var rel = setInterval(tique, 1000);
  });

  /* ────────────────── lista de qualificação (marcar 4 de 6) ────────────────── */

  var lista = document.querySelector('.hw-close__list');
  if (lista) {
    [].forEach.call(lista.querySelectorAll('li'), function (li) {
      li.setAttribute('role', 'checkbox');
      li.setAttribute('aria-checked', 'false');
      li.setAttribute('tabindex', '0');
      li.style.cursor = 'pointer';
      function alterna() {
        var marcado = li.classList.toggle('hw-marcado');
        li.setAttribute('aria-checked', marcado ? 'true' : 'false');
      }
      li.addEventListener('click', alterna);
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); alterna(); }
      });
    });
  }

  /* ──────────── barra de estoque: enche ao entrar em cena ────────────
     A largura nasce em 0 no CSS e só vai a 91% quando a classe .on entra.
     Disparar na entrada em cena e não no load faz o movimento acontecer
     enquanto o olho está na barra; disparando no load a animação termina
     antes de alguém ver. Failsafe de 1,2s cobre navegador sem observer
     e o caso da barra já estar visível de cara. */

  (function () {
    var barra = document.getElementById('hw-progress');
    if (!barra) return;
    var ligou = false;
    function liga() { if (!ligou) { ligou = true; barra.classList.add('on'); } }
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (e.isIntersecting) { liga(); obs.disconnect(); } });
      }, { threshold: 0.35 });
      obs.observe(barra);
    }
    setTimeout(liga, 1200);
  })();


  /* ──────────── recorrência como padrão, com saída por caixa de seleção ────────────
     A saída era um link rotulado "BUY ONCE — NO SAVINGS": amarrava duas decisões
     numa só e rotulava sair como perder. Virou caixa de seleção marcada. Os cards
     decidem quanto, a caixa decide se repete.
     A cadência é derivada do plano do pacote selecionado, porque um número fixo
     mentiria em dois dos três: 1 frasco é mensal, 3 é trimestral, 6 é semestral. */

  (function () {
    var caixa = document.getElementById('hw-sub');
    var plano = document.getElementById('hw-plan');
    if (!caixa || !plano) return;


    function pinta() {
      var assinando = caixa.checked;

      [].forEach.call(document.querySelectorAll('.product-offer__variant-item'), function (c) {
        var p = c.querySelector('.price'), sv = c.querySelector('.product-offer__variant-saving');
        if (p) p.textContent = assinando ? c.getAttribute('data-sub-price') : c.getAttribute('data-once-price');
        if (sv) sv.textContent = assinando ? c.getAttribute('data-sub-savings') : c.getAttribute('data-once-savings');
      });
      [].forEach.call(document.querySelectorAll('.btn-price'), function (b) {
        b.textContent = assinando ? b.getAttribute('data-sub') : b.getAttribute('data-once');
      });
      plano.disabled = !assinando;   // desabilitado não é enviado no formulário

      var marcado = document.querySelector('input.hw-vr:checked');
      var cartao = marcado ? document.querySelector('label.hw-vl[for="' + marcado.id + '"] [data-plan]') : null;
      var semanas = parseInt(cartao ? cartao.getAttribute('data-weeks') : '', 10) || 4;

      var cad = document.getElementById('hw-cadence');
      if (cad) cad.textContent = assinando
        ? 'Lieferung und Abbuchung alle ' + semanas + ' Wochen. Keine Mindestlaufzeit, jederzeit kündbar.'
        : 'Einmalkauf. Keine wiederkehrende Abbuchung.';

      // o guia acompanha qualquer pedido: a promessa do listicle e da imagem da
      // oferta e "with every order today", entao nao ha degrau de pacote aqui
      var unl = document.getElementById('hw-unlock'), ut = document.getElementById('hw-unlock-txt');
      if (unl && ut) {
        unl.className = 'hw-unlock got';
        ut.textContent = 'Zu jeder Bestellung';
      }

      var aviso = document.querySelector('.hw-sub-aviso');
      if (aviso) aviso.style.display = assinando ? '' : 'none';

      // em compra única as duas linhas descreveriam algo falso; trocam de texto
      // em vez de sumir, para que desmarcar seja confirmado e não punido
      var lista = document.querySelector('.product-offer__info-checklist');
      if (lista) {
        var v = lista.querySelectorAll('.value');
        if (v[0]) v[0].textContent = assinando ? 'Lieferung alle ' + semanas + ' Wochen' : 'Einmalkauf';
        if (v[1]) v[1].textContent = assinando ? 'Jederzeit kündbar' : 'Keine wiederkehrende Abbuchung';
      }
    }

    caixa.addEventListener('change', pinta);
    [].forEach.call(document.querySelectorAll('input.hw-vr'), function (r) {
      r.addEventListener('change', pinta);
    });
    pinta();
  })();


  /* ──────────── data de entrega calculada ────────────
     O markup já trazia data-days no .hw-stock, mas a data era string fixa e
     venceu. Aqui ela passa a ser contada em dias ÚTEIS a partir de hoje.
     Três dias porque é o extremo rápido da própria política de envio da loja,
     que promete 1 a 2 dias úteis de processamento mais 2 a 5 de entrega. Ir
     abaixo disso faria a página contradizer a política que ela mesma linka. */
  (function () {
    var linha = document.querySelector('.hw-stock');
    if (!linha) return;
    var alvo = linha.querySelector('.date');
    if (!alvo) return;
    var uteis = parseInt(linha.getAttribute('data-days'), 10);
    if (!uteis || uteis < 1) uteis = 3;

    var d = new Date();
    var somados = 0;
    while (somados < uteis) {
      d.setDate(d.getDate() + 1);
      var s = d.getDay();
      if (s !== 0 && s !== 6) somados++;
    }
    var meses = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
    var n = d.getDate();
    var sufixo = (n % 10 === 1 && n !== 11) ? 'st'
               : (n % 10 === 2 && n !== 12) ? 'nd'
               : (n % 10 === 3 && n !== 13) ? 'rd' : 'th';
    alvo.textContent = ' - Lieferung bis ' + n + '. ' + meses[d.getMonth()];
  })();

})();

/* ──────────── o botão da oferta leva só o pacote escolhido ────────────
   O formulário posta em /cart/add e volta direto para o checkout. Sem esvaziar o
   carrinho antes, quem volta para trocar de pacote chega ao checkout com todos os
   pacotes que clicou. Aqui o carrinho é esvaziado e só então o formulário segue.
   Se a limpeza falhar ou passar de 3 segundos, o formulário segue como antes. */
(function () {
  'use strict';
  var form = document.querySelector('#product-form form[action$="/cart/add"]');
  if (!form) return;
  var emAndamento = false;
  // voltar pelo botão do navegador restaura a página da memória: libera de novo
  window.addEventListener('pageshow', function () { emAndamento = false; });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (emAndamento) return;
    emAndamento = true;
    var enviado = false;
    function envia() {
      if (enviado) return;
      enviado = true;
      HTMLFormElement.prototype.submit.call(form);
    }
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var limite = setTimeout(envia, 3000);
    fetch(raiz + 'cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function () { clearTimeout(limite); envia(); }, function () { clearTimeout(limite); envia(); });
  });
})();
